import Layout from "../../../../src/components/layout";
import * as React from 'react';
export default {
  Layout,
  React
};